import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IFile } from "../interface/IFile";
import IBaseResponse from "../interface/IBaseResponse";
import { saveByteArray } from "src/util/saveByteArray";
import { FilesCategoryEnum, FilesCategoryEnumLabel } from "../enum/FilesCategoryEnum";
import { FileVersionEnum } from "../enum/FileVersionEnum";

enum FileServiceEnum {
  getAll = "/get-all",
  createOrUpdate = "/create-or-update",
  download = "/download",
  downloadTemplateDocumentSpecial = "/template-special",
  downloadTemplateDocument = "/template",
  getUrlPreSignedS3 = "/url/presigned/s3"
}

export default class FileService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/file");
  }

  public getAll = async (): Promise<IFile[]> => await this.GET(FileServiceEnum.getAll);
  public createOrUpdate = async (data: IFile): Promise<IBaseResponse> => await this.POST(FileServiceEnum.createOrUpdate, data);
  public getUrlPreSignedS3 = async () => await this.GET(FileServiceEnum.getUrlPreSignedS3);

  public download = async (file: IFile) => {
    const endpoint = FileServiceEnum.download + "?id=" + file.id;
    const data = await this.GET(endpoint, "blob");
    saveByteArray(file.fileName, data);
    return data;
  };

  public downloadTemplateDocument = async (category: FilesCategoryEnum, version: FileVersionEnum, extension: string) => {
    if (extension === undefined || extension === null) {
      extension = ".xlsx";
    }

    const filename = FilesCategoryEnumLabel.get(category) + extension;
    const endpoint = `${FileServiceEnum.downloadTemplateDocument}?documentCategory=${FilesCategoryEnum[category]}&documentVersion=${FileVersionEnum[version]}`;
    const data = await this.GET(endpoint, "blob");

    saveByteArray(filename, data);
    return data;
  };


}



// WEBPACK FOOTER //
// ./src/services/api/File.service.ts